import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material"; // Use single quotes for consistency
import { Link } from "react-router-dom";
import IncomePage from "../IncomePage/IncomePage";

export default function MainIncomesPage() {
  const [tabValue, setTabValue] = useState(0);
  const [unsavedIncomes, setUnsavedIncomes] = useState(false);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <Tabs
        sx={{
          "height": { xs: "35px", sm: "50px" },
          "& .MuiTabs-flexContainer": {
            gap: "1rem",
          },
          "margin": 0,
          "width": "100%",
        }}
        value={tabValue}
        onChange={handleTabChange}
      >
        <Tab
          component={Link}
          disabled={unsavedIncomes}
          label="Crear nuevo ingreso"
          style={{
            backgroundColor: "#123B64",
            color: "white",
            marginLeft: "85%",
          }}
          sx={{
            height: { xs: "35px", sm: "50px" },
            padding: 1,
            maxHeight: "auto",
            minHeight: "auto",
            borderRadius: "5px",
            justifyContent: "center",
          }}
          to="/electronic-bills?redirectTo=/incomes/"
        />
      </Tabs>
      <br />
      <IncomePage onDataChange={setUnsavedIncomes} />
    </div>
  );
}
